import { toast } from 'sonner';
import type { ToastConfig } from './buildFinalizationToast';

type ReconToast = Omit<ToastConfig, 'description'> & { description?: string };

// Banker Recon keeps its outcome objects; render them through the portal's mounted Toaster.
export function showBankerReconToast({ title, description, variant }: ReconToast) {
  return variant === 'destructive'
    ? toast.error(title, { description })
    : toast(title, { description });
}
